import { createContext } from 'react';

export const NavbarHamburgerMenuContext = createContext({ inNavbarHamburgerMenu: false });
export const NavbarMenuSubMenuContext = createContext({ inNavbarMenuSubMenu: false });
